import React, { useCallback, memo } from 'react';
import { FormInput, FormLabel, FormGroup, HelpText, FormSelect } from '../../common/form';
import AgentServicesContainer from '../tools/AgentServicesContainer';

import styles from '../styles/AgentSettings.module.css';

const AgentToolsTab = ({ data, onChange, agentId }) => {
    const handleChange = useCallback((field, value) => {
        onChange({ [field]: value });
    }, [onChange]);

    return (
        <div className={styles.tabContent}>
            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>Tool Configuration</h3>
                <p className={styles.sectionDescription}>
                    Configure how your agent uses tools and external services.
                </p>

                <FormGroup>
                    <FormLabel htmlFor="toolsVisibility">
                        Show Tool Results to Users
                    </FormLabel>
                    <FormSelect
                        id="toolsVisibility"
                        name="toolsVisibility"
                        value={data.toolsVisibility || 'ALL'}
                        onChange={value => handleChange('toolsVisibility', value)}
                        options={[
                            { value: 'ALL', label: 'Show details and results' },
                            { value: 'TASK_ONLY', label: 'Show only running task (no details/results)' },
                            { value: 'HIDDEN', label: 'Hide tools entirely' },
                        ]}
                    />
                    <HelpText>
                        Owners always see full tool details regardless of this setting.
                    </HelpText>
                </FormGroup>
                <FormGroup>
                    <FormLabel htmlFor="maxToolSteps">
                        Maximum Tool Steps
                    </FormLabel>
                    <FormInput
                        type="number"
                        id="maxToolSteps"
                        value={data.maxToolSteps}
                        onChange={value => handleChange('maxToolSteps', parseInt(value) || 1)}
                        min="1"
                        max="20"
                        placeholder="5"
                    />
                    <HelpText>
                        Maximum number of tool calls per conversation turn
                    </HelpText>
                </FormGroup>
            </div>

            <div className={styles.section} style={{ minHeight: '100vh' }}>
                <h3 className={styles.sectionTitle}>Available Tools</h3>
                <p className={styles.sectionDescription}>
                    Select the tools your agent can use. Some tools may require additional authentication.
                </p>

                <AgentServicesContainer agentId={agentId} />
            </div>
        </div>
    );
};

export default memo(AgentToolsTab);
